import React from 'react';
import Input from '../../../components/ui/Input';
import Select from '../../../components/ui/Select';
import { Checkbox, CheckboxGroup } from '../../../components/ui/Checkbox';

const ProfessionalInfoStep = ({ formData, errors, onChange, onCheckboxChange }) => {
  const experienceOptions = [
    { value: '0-2', label: '0-2 ans' },
    { value: '3-5', label: '3-5 ans' },
    { value: '6-10', label: '6-10 ans' },
    { value: '11-15', label: '11-15 ans' },
    { value: '16+', label: '16+ ans' }
  ];

  const specializationList = [
    { id: 'academic', label: 'Orientation Académique' },
    { id: 'career', label: 'Orientation Professionnelle' },
    { id: 'psychology', label: 'Psychologie Scolaire' },
    { id: 'special-needs', label: 'Besoins Spéciaux' },
    { id: 'university', label: 'Admission Universitaire' },
    { id: 'vocational', label: 'Formation Professionnelle' }
  ];

  return (
    <div className="space-y-4 md:space-y-5 lg:space-y-6">
      <div className="bg-purple-50 border border-purple-200 rounded-lg p-4 md:p-5 lg:p-6">
        <div className="flex items-start gap-3">
          <div className="flex-shrink-0 w-8 h-8 md:w-10 md:h-10 lg:w-12 lg:h-12 bg-purple-500 rounded-full flex items-center justify-center">
            <span className="text-white text-sm md:text-base lg:text-lg font-semibold">2</span>
          </div>
          <div>
            <h3 className="text-base md:text-lg lg:text-xl font-semibold text-gray-900 mb-1 md:mb-2">
              Informations Professionnelles
            </h3>
            <p className="text-sm md:text-base text-gray-600">
              Partagez votre expérience et vos qualifications professionnelles.
            </p>
          </div>
        </div>
      </div>

      <Input
        label="Numéro de Licence Professionnelle"
        type="text"
        name="licenseNumber"
        placeholder="Ex: CO-SN-2024-12345"
        description="Numéro d'identification professionnel délivré par l'autorité compétente"
        value={formData?.licenseNumber}
        onChange={onChange}
        error={errors?.licenseNumber}
        required
      />

      <Select
        label="Années d'Expérience"
        options={experienceOptions}
        value={formData?.yearsExperience}
        onChange={(value) => onChange({ target: { name: 'yearsExperience', value } })}
        placeholder="Sélectionnez votre expérience"
        error={errors?.yearsExperience}
        required
      />

      <div>
        <CheckboxGroup 
          label="Spécialisations" 
          error={errors?.specialization}
        >
          <p className="text-sm text-gray-600 mb-3 md:mb-4">
            Sélectionnez vos domaines de spécialisation (au moins un)
          </p>
          <div className="grid grid-cols-1 md:grid-cols-2 gap-3 md:gap-4">
            {specializationList?.map((spec) => (
              <Checkbox
                key={spec?.id}
                label={spec?.label}
                checked={formData?.specialization?.includes(spec?.id)}
                onChange={(e) => onCheckboxChange('specialization', spec?.id, e?.target?.checked)}
              />
            ))}
          </div>
        </CheckboxGroup>
      </div>

      <div>
        <label className="block text-sm font-medium text-gray-700 mb-2">
          Certifications et Formations Complémentaires
        </label>
        <textarea
          name="certifications"
          value={formData?.certifications}
          onChange={onChange}
          placeholder="Listez vos certifications, diplômes supplémentaires, et formations spécialisées..."
          rows={4}
          className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-purple-500 focus:border-transparent resize-none"
        />
        <p className="text-xs text-gray-600 mt-1">
          Exemple: Master en Psychologie de l'Éducation, Certification en Orientation Professionnelle
        </p>
      </div>
    </div>
  );
};

export default ProfessionalInfoStep;